import { SvgIcon, SvgIconProps } from '@mui/material';

const InfluencerMonitorIcon = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    width="70"
    height="48"
    viewBox="0 0 70 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.8426 0H15.9999V3.15796C15.9999 6.93416 12.9334 10.0006 9.15726 10.0006H0V6.84266C0 3.06646 3.06643 0 6.8426 0Z"
      fill="#ffffff"
    />
    <path
      d="M13.9671 12H2.03275C0.910093 12 0 12.9101 0 14.0328V45.9672C0 47.0899 0.910093 48 2.03275 48H13.9671C15.0898 48 15.9999 47.0899 15.9999 45.9672V14.0328C15.9999 12.9101 15.0898 12 13.9671 12Z"
      fill="#ffffff"
    />
    <path
      d="M18.0005 0H23.0131C29.0767 0 34.0003 4.92365 34.0003 10.9873V47.9963H28.9877C22.9241 47.9963 18.0005 43.0726 18.0005 37.009V0Z"
      fill="#ffffff"
    />
    <path
      d="M41.0123 47.9963H35.9997L35.9997 10.9874C35.9997 4.9237 40.9233 4.95911e-05 46.9869 4.95911e-05H51.9995L51.9995 37.009C51.9995 43.0727 47.0759 47.9963 41.0123 47.9963Z"
      fill="#ffffff"
    />
    <path
      d="M54 0.00244141H59.0126C65.0763 0.00244141 69.9999 4.92609 69.9999 10.9898V47.9987H64.9872C58.9236 47.9987 54 43.0751 54 37.0114V0.00244141Z"
      fill="#ffffff"
    />
  </SvgIcon>
);

export default InfluencerMonitorIcon;
